(function () {
  // Configuration for Images
  const TRUSTPILOT_MAPPINGS = {
    'trustpilot_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857178777_trustpilot_image.png",
    'trustpilot_score_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857231246_trustScore.png",
    'trustpilot_doc_79_OFF_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857143959_doc_79_trust.webp",
    'trustpilot_doc_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764925192353_Group_1000004641.webp",
    'trustpilot_image_white': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764924309253_Group_401467.png",
    'trustpilot_doc_79_OFF_image_half_white': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764924450582_Group_1000004640.webp",
    'trustpilot_doc_79_OFF_image_half_white_eye': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1765545878142_Group_401581.webp",
    'trustpilot_doc_79_OFF_image_eye': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1765546574498_Group_401445.webp",
  };

  // 1. UPDATE SALE TEXTS (Scoped to a specific root element)
  function processSaleTexts(root) {
    if (!root || !root.querySelectorAll) return;
    
    // Plain Sale Text
    const plainSales = root.querySelectorAll('[sale_plain="true"]');
    plainSales.forEach(el => {
      // Check first to prevent loop/reflow
      if (el.textContent.trim() !== 'Anniversary Sale') {
        el.textContent = 'Anniversary Sale';
      }
    });

    // Emoji Sale Text
    const emojiSales = root.querySelectorAll('[sale_with_emojie="true"]');
    emojiSales.forEach(el => {
      if (!el.textContent.includes('Anniversary Sale')) {
        el.style.textTransform = 'uppercase';
        el.textContent = '🎉 Anniversary Sale 🎉';
      }
    });
  }

  // 2. REPLACE IMAGES (Scoped and Checked)
  function processImages(root) {
    if (!root || !root.querySelectorAll) return;

    // We iterate our mappings keys to find matching elements
    Object.entries(TRUSTPILOT_MAPPINGS).forEach(([attr, url]) => {
      // Find images with this attribute inside the root
      const images = root.querySelectorAll(`img[${attr}="true"]`);
      images.forEach(img => {
        // IDEMPOTENCY CHECK: Only update if src is different
        // This prevents the observer from firing infinitely on the same image
        if (img.getAttribute('src') !== url) {
          img.setAttribute('src', url);
          img.setAttribute('data-src', url); // Update lazy load attr if present
        }
      });
    });
  }

  // 3. REPLACE TEXT (Scoped TreeWalker)
  function processTextNodes(root) {
    // If root is a text node, process it directly
    if (root.nodeType === 3) {
      handleTextNode(root);
      return;
    }

    // Otherwise walk the tree inside this root
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while (node = walker.nextNode()) {
      handleTextNode(node);
    }
  }

  // Helper to strictly replace text without looping
  function handleTextNode(node) {
    const originalText = node.nodeValue; // Use nodeValue for efficiency
    if (!originalText) return;

    let newText = originalText;

    // Apply replacements
    
    newText = newText.replace(/29,000/g, "100,000");
    newText = newText.replace(/30,000/g, "100,000");
    newText = newText.replace(/39,000/g, "100,000");

    // CRITICAL: Only write to DOM if text actually changed
    if (newText !== originalText) {
      node.nodeValue = newText;
    }
  }

  // === MASTER PROCESSOR ===
  // Runs all logic on a specific node (and its children)
  function processAll(node) {
    // Ensure node is an Element (type 1) before using querySelector
    if (node.nodeType === 1) {
      processSaleTexts(node);
      processImages(node);
      processTextNodes(node);
    } 
    // If it's a Text Node (type 3), just check text
    else if (node.nodeType === 3) {
      handleTextNode(node);
    }
  }

  function initObserver() {
    const body = document.body;
    if (!body) {
      requestAnimationFrame(initObserver);
      return;
    }

    // 1. Run immediately on existing content (Global scan once)
    processAll(body);

    // 2. Setup Observer
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        // ONLY look at added nodes. Do not re-scan the body.
        mutation.addedNodes.forEach(addedNode => {
          processAll(addedNode);
        });
      });
    });

    observer.observe(body, {
      childList: true,
      subtree: true
    });
  }

  // Start
  initObserver();

})();


























// (function () {

//   function updateSaleTexts(root) {
//     if (!root || !root.querySelectorAll) return;

//     root.querySelectorAll('[sale_plain="true"]').forEach(el => {
//       if (el.textContent.trim() !== 'Christmas Sale') {
//         el.textContent = 'Christmas Sale';
//       }
//     });

//     root.querySelectorAll('[sale_with_emojie="true"]').forEach(el => {
//       if (!el.textContent.includes('Christmas Sale')) {
//         el.style.textTransform = 'uppercase';
//         el.textContent = '🎁 Christmas Sale 🎁';
//       }
//     });
//   }

//   function replaceCustomerCount() {
//     function replaceAllText(find, replace) {
//       const walker = document.createTreeWalker(
//         document.body,
//         NodeFilter.SHOW_TEXT,
//         null,
//         false
//       );

//       let node;
//       while (node = walker.nextNode()) {
//         node.textContent = node.textContent.replace(find, replace);
//       }
//     }

//     // Apply all replacements:
//     replaceAllText(/4\.8\/5/g, "4.5/5");
//     replaceAllText(/4\.7\/5/g, "4.5/5");

//     replaceAllText(/29,000/g, "59,000");
//     replaceAllText(/30,000/g, "59,000");
//     replaceAllText(/39,000/g, "59,000");
//   }

//   function replaceTrustPilotImages() {
//     const mappings = {
//       'trustpilot_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857178777_trustpilot_image.png",
//       'trustpilot_score_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857231246_trustScore.png",
//       'trustpilot_doc_79_OFF_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764857143959_doc_79_trust.webp",
//       'trustpilot_doc_image': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764925192353_Group_1000004641.webp",
//       'trustpilot_image_white': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764924309253_Group_401467.png",
//       'trustpilot_doc_79_OFF_image_half_white': "https://assets.checkoutchamp.com/9bbb111c-d766-4a84-949d-b712388a242f/1764924450582_Group_1000004640.webp"
//     };

//     Object.entries(mappings).forEach(([attribute, url]) => {
//       $(`img[${attribute}="true"]`).each(function () {
//         $(this).attr("src", url);
//         $(this).attr("data-src", url);
//       });
//     });
//   }


//   // Run immediately on whatever DOM exists (no flicker)
//   updateSaleTexts(document);

//   // ---- WAIT FOR BOTH document.body AND Checkout Champ DOM ----
//   function initObserver() {
//     const body = document.body;

//     // If body is missing, try again shortly
//     if (!body) {
//       requestAnimationFrame(initObserver);
//       return;
//     }

//     // If target elements do NOT exist yet, Champ hasn’t injected them
//     const hasSaleElements =
//       document.querySelector('[sale_plain], [sale_with_emojie], [trustpilot_image_white]');

//     if (!hasSaleElements) {
//       // Try again until the Champ DOM is present
//       requestAnimationFrame(initObserver);
//       return;
//     }

//     // Now body exists AND elements exist → safe to attach observer
//     const observer = new MutationObserver(mutations => {

//       replaceCustomerCount()
//       replaceTrustPilotImages()
      
//       mutations.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//           if (node.nodeType === 1) {
//             updateSaleTexts(node);
//           }
//         });
//       });
//     });

//     observer.observe(body, {
//       childList: true,
//       subtree: true
//     });

//     // Safety: update again after observer starts
//     updateSaleTexts(document);
//   }

//   initObserver();
// })();
